import styled from "styled-components";

export const Gif = styled.img`
  border-radius: 0.75rem;
  width: 100%;
  height: auto;
  cursor: pointer;
  margin-bottom: 6px;
`;
